import React from 'react';
import {
  Hero,
  WaitlistForm,
  ForBothSides,
  MarqueeBar,
  HowItWorks,
  WhyStoveShare,
} from '../components/sections';
import { submitWaitlistEntry } from '../services/waitlist';

const Home = () => {
  const handleWaitlistSubmit = async (data) => {
    await submitWaitlistEntry(data);
  };

  return (
    <>
      <Hero />
      <WaitlistForm onSubmit={handleWaitlistSubmit} />
      <ForBothSides />
      <MarqueeBar />
      <HowItWorks />
      <WhyStoveShare />
    </>
  );
};

export default Home;